'use strict';

//	Disable logging
console.log = function () {
};
console.error = function () {
};
console.warn = function () {
};


// Homepage Navbar Color Change
//===========================================
var scrollEffects = function ($) {
	var $navbar = $('#main-navbar');
	var navBreakPoint = 50;
	var scrollPosition = $(document).scrollTop();

	var addBackgroundColor = function () {
		$navbar.addClass('solid-bg');
	};

	var removeBackgroundColor = function () {
		$navbar.removeClass('solid-bg');
	};

	return {
		init: function () {

			$(window).load(function () {
				if (scrollPosition > navBreakPoint) {
					addBackgroundColor();
				}
			});

			$(window).scroll(function () {
				var lastPos = scrollPosition;
				var newPosition = $(document).scrollTop();
				var scrollingDown = newPosition > lastPos;
				var crossedBreakpoint = false;

				if ((lastPos <= navBreakPoint && newPosition > navBreakPoint) || (lastPos >= navBreakPoint && newPosition < navBreakPoint)) {
					crossedBreakpoint = true;
				}

				if (scrollingDown && crossedBreakpoint) {
					addBackgroundColor();
				}

				if (!scrollingDown && crossedBreakpoint) {
					removeBackgroundColor();
				}

				scrollPosition = newPosition;
			});
		}
	}

}(jQuery);

if (jQuery('body').hasClass('home')) {
	scrollEffects.init();
}

// Smooth Scroll
//===========================================
(function ($) {
	$('a[href*="#"]:not([href="#"])').click(function () {

		if (!$(this).data('smooth-scroll')) {
			return;
		}

		var $target = $(this.hash);

		if ($target.length) {

			$('html, body').animate({
				scrollTop: $target.offset().top
			}, 1000);

			return false;
		}
	});
})(jQuery);

// DL Panel Collapse
//===========================================
var toggleDlPanel = function ($) {

	var expand = function (target) {
		var $target = target;
		var height = $target.children('dt').outerHeight();
		$target.css({'height': height}).addClass('in');
		var expandHeight = $target.get(0).scrollHeight;

		$target.animate({
			'height': expandHeight
		}, 400, function () {
			$target.find('dt a').attr('aria-expanded', 'true');
		});
	};

	var collapse = function (target) {
		var $target = target;
		var height = $target.children('dt').outerHeight();

		$target.animate({
			'height': height
		}, 400, function () {
			$target.removeClass('in').attr('style', '');
			$target.find('dt a').attr('aria-expanded', 'false');
		});
	};

	var toggle = function (target) {
		var $target = target;
		var $trigger = $target.find('dt a');
		var targetState = $trigger.attr('aria-expanded') == 'false' ? 'collapsed' : 'expanded';

		if (targetState === 'expanded') {
			collapse($target);
		} else if (targetState === 'collapsed') {
			expand($target);
		}
	};

	return {
		init: function () {

			$('a[href*="#"]:not([href="#"])').click(function (e) {

				if ($(this).data('toggle') === 'collapse-panel') {
					e.preventDefault();
					toggle($(this.hash));
				}

			});
		}
	}
}(jQuery);

toggleDlPanel.init();

// Map Scripts
//===========================================
var usMapDataChart = function ($) {

	/**
	 * How this Works
	 * ==============
	 *
	 * When the page loads we add classes to states and based on the data
	 *
	 * When the user clicks on a checkbox with a data-map-toggle="class" the
	 * class will be toggled on the <svg> element.  That class is responsible for
	 * showing and hiding states and pins based on the classes added previously
	 *
	 */

	var $svgMap = $('#us-map');
	var previousLocation = 'off-map';

	// Adds classes to map states and pins on load
	var initMapClasses = function () {

		// Loop through state classes
		for (var cssClass in window.data.stateClasses) {
			addStateClass(cssClass, window.data.stateClasses[cssClass]);
		}

		// Loop through pin classes
		for (cssClass in window.data.pinClasses) {
			addPinClass(cssClass, window.data.pinClasses[cssClass]);
		}
	};

	var addStateClass = function (className, statesData) {

		$.each(statesData, function (i, state) {
			$svgMap.find('#' + state + ' > .state').addClass(className);
		});
	};

	var addPinClass = function (className, statesData) {

		$.each(statesData, function (i, state) {
			// Set to true when match is found
			// Prevents matching twice in same loop
			var foundMatch = false;

			// Loop through pins in state and add class to first one without a class
			// also add class to text element so that text appears if pin is active
			$svgMap.find('#' + state + ' > .state-pin').each(function () {
				var numClasses = $(this).attr('class').split(' ').length;

				// Each pin should have one class except pins on the side of the page
				// Subtract 1 to compensate for those pins
				if ($(this).hasClass('external')) {
					numClasses--;
				}

				// Adds class to first pin without a program class
				if (numClasses === 1 && !foundMatch) {
					$(this).addClass(className);
					$(this).siblings('.state-text').addClass(className);
					foundMatch = true;
				}
			});
		});
	};

	// Toggles classes on <svg> element
	var toggleMapClass = function (cssClass) {
		$svgMap.toggleClass(cssClass);
	};

	// Returns state abbreviation if mouse over state, else returns 'off-map'
	var getMouseLocation = function (e) {
		var classes = '';

		// First check to see if on map SVG or other part of page
		if (e.target.farthestViewportElement === null || e.target.farthestViewportElement === undefined) {
			return 'off-map';
		}

		// Find the state
		if (e.target.farthestViewportElement.id === 'us-map') {

			// Get classes of what we are hovering on the map
			classes = e.target.className.baseVal.split(' ');

			// Check if on a state or external pin/text
			if (classes.indexOf('external') > -1 || e.target.nodeName === 'text') {
				return 'off-map';
			} else {
				return e.target.parentNode.id;
			}

		} else {
			return 'off-map';
		}

	};

	var onMouseMove = function (e) {
		var currentLocation = getMouseLocation(e);

		// Move popup if on screen
		if (currentLocation !== 'off-map' && $('#state-popup').length === 1) {
			movePopup(e.pageX, e.pageY);
		}

		// If switching between states
		if (previousLocation !== currentLocation && currentLocation !== 'off-map') {
			// Hover animation for states
			toggleStateHover(currentLocation);

			// Toggle popup when changing states
			togglePopup(currentLocation);

		} else if (previousLocation !== currentLocation && currentLocation === 'off-map') {
			// If going off map
			$('#us-map .state').removeClass('hover');
			hidePopup();
		}

		// Set previous location value
		previousLocation = currentLocation;
	};

	// Hover state for map states
	// Cant do with css :hover because of map pins
	var toggleStateHover = function (currentState) {
		// If .length === 2 then we have a state abbreviation with 2 letters
		// If not then we are not hoving over a state

		// Hovering from one state to another
		if (currentState.length === 2 && previousLocation.length === 2) {
			$('#us-map #' + currentState + ' .state').addClass('hover');
			$('#us-map #' + previousLocation + ' .state').removeClass('hover');
		}

		// Currently not hovering on a state but was previously on a state,
		// remove hover state from previous state
		if (currentState.length !== 2 && previousLocation.length === 2) {
			$('#us-map #' + previousLocation + ' .state').removeClass('hover');
		}

		// Currently hovering on a state but previously was not
		if (currentState.length === 2 && previousLocation.length !== 2) {
			$('#us-map #' + currentState + ' .state').addClass('hover');
		}
	};

	var togglePopup = function (state) {
		// Show if there is data for state, if not hide popup
		if (window.data.stateData[state]) {
			showPopup(window.data.stateData[state]);
		} else {
			hidePopup();
		}
	};

	var showPopup = function (data) {
		// If popup on screen replace inner html, if not then add popup to page
		if ($('#state-popup').length === 1) {
			$('#state-popup').html(popUpContent(data));
		} else {
			$(popUpContainer).appendTo('body').html(popUpContent(data)).fadeIn(300);
		}
	};

	var hidePopup = function () {
		$('#state-popup').remove();
	};

	var movePopup = function (mouseX, mouseY) {
		// Make sure popup doesn't go off of right side of screen
		var windowWidth = window.innerWidth;
		var popUpWidth = $('#state-popup').width();
		var crossoverPoint = windowWidth - popUpWidth - 50;
		var offsetX = mouseX > crossoverPoint ? -1 * popUpWidth - 25 : 25;

		// Make sure popup doesn't go off of bottom of screen
		var windowHeight = $(window).height();
		var scrollTop = $(window).scrollTop();
		var windowBottom = windowHeight + scrollTop;
		var popupBottom = $('#state-popup').outerHeight() + mouseY;
		var offsetY = -1 * $(window).scrollTop() - 25;

		if (popupBottom > windowBottom) {
			offsetY = -1 * $(window).scrollTop() - (popupBottom - windowBottom) - 25;
		}

		// Position the popup
		$('#state-popup').css({
			left: mouseX + offsetX,
			top: mouseY + offsetY
		});
	};
	console.log('TEST');

	var popUpContainer = '<article class="state-popup" id="state-popup"></article>';

	var popUpContent = function (data) {
		var mapPin = '<svg class="map-pin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.9 20.7" width="14.9" height="20.7"><path class="pin" d="M6.7,19.2a52.3,52.3,0,0,1-3.1-4.4C1.5,11.5.4,9,.4,7.5A8.1,8.1,0,0,1,.9,4.8,8.6,8.6,0,0,1,2.4,2.6,8.6,8.6,0,0,1,4.6,1.1,6.5,6.5,0,0,1,7.3.6a8.1,8.1,0,0,1,2.7.5,8.6,8.6,0,0,1,2.2,1.5,8.6,8.6,0,0,1,1.5,2.2,6.5,6.5,0,0,1,.5,2.7c0,1.6-1.1,4-3.2,7.3a52.3,52.3,0,0,1-3.1,4.4l-.7.9Z"/></svg>';

		var programTemplates = {
			voucher: '<li class="state-program voucher-pin">' + mapPin + 'Voucher Program</li>',
			esa: '<li class="state-program esa-pin">' + mapPin + 'Education Savings Account</li>',
			itt: '<li class="state-program itt-pin">' + mapPin + 'Tuition Tax Credit</li>',
			stc: '<li class="state-program stc-pin">' + mapPin + 'Scholarship Tax Credit</li>',
			snp: '<li class="state-program snp-pin">' + mapPin + 'Special Needs Program</li>',
			pcs: '<li class="state-program pcs-pin">' + mapPin + 'Public Charter Schools</li>'
		};

		var template = '<h3 class="state-name">' + data.stateName + '</h3>';
		template += '<ul class="state-stats">';
		template += '<li class="state-enrollment"><div>Total Student Participation</div><strong class="total-students">' + data.studentPopulation.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '</strong></li>';

		//console.log(data);

		// Loop through programs and add markup
		for (var i = 0; i < data.programs.length; i++) {
			var program = data.programs[i];
			template += programTemplates[program];
		}
		template += '</ul>';

		return template;
	};

	return {
		init: function () {

			// Only load on map page
			if ($svgMap.length === 1) {

				// Add state and pin classes
				initMapClasses();

				// If going back to map page init checked filters
				$('input[data-map-toggle]:checked').each(function () {
					toggleMapClass($(this).data('map-toggle'));
				});

				// Filters select
				$('input[data-map-toggle]').on('change', function () {
					toggleMapClass($(this).data('map-toggle'));
				});

				// Reset Button
				$('button[data-map-toggle="reset"]').on('click', function () {
					$('input[data-map-toggle]:checked').prop('checked', false).trigger('change');
				});

				//	Select All Button
				$('button[data-map-toggle="select-all"]').on('click', function () {
					$('input[data-map-toggle]:not(:checked)').prop('checked', true).trigger('change');
				});

				// State popup and hover
				$(window).on('mousemove', function (e) {
					onMouseMove(e);
				});

				$(window).on('touchmove', function () {
					togglePopup();
				});

				// Go to state page on click
				$('.state, .state-pin:not(.external)').on('click', function () {
					var state = $(this).parent('.state-group').attr('id');
					window.location.href = window.data.stateData[state].link;
				});
			}
		}
	}
}(jQuery);

usMapDataChart.init();


// Video Placeholder
//===========================================
var placeholderVideo = function ($) {

	var modalTemplate = `<div class="modal video-modal fade" id="video-modal" tabindex="-1" role="dialog">
                          <div class="modal-dialog" role="document">
                            <div class="modal-content">
                              <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div><!-- /.modal-header -->
                              <div class="modal-body">
                                <div class="embed-responsive embed-responsive-16by9">
                                  <iframe class="embed-responsive-item" id="video-frame" src="" frameborder="0" allowfullscreen></iframe>
                                </div><!-- /.embed-responsive -->
                              </div><!-- /.modal-body -->
                            </div><!-- /.modal-content -->
                          </div><!-- /.modal-dialog -->
                        </div><!-- /.modal -->`;

	var playButtonTemplate = `<button class="play-button">
                                <span class="sr-only">Play Video</span>
                                <span class="button-icon" aria-hidden="true"><i class="fa fa-youtube-play"></i></span>
                              </button>`;

	var spinnerTemplate = `<span class="spinner">
                             <span class="sr-only">Loading...</span>
                             <span class="spinner-icon"><i class="fa fa-spinner fa-pulse"></i></span>
                           </span><!-- /.spinner -->`;

	var playVideoModal = function () {
		var $placeholder = $(this).parent();
		var videoId = $placeholder.data('video-placeholder');
		var videoUrl = `https://www.youtube.com/embed/${videoId}?rel=0&autoplay=1`;

		// Add spinner icon
		$placeholder.html(spinnerTemplate);

		// Load video into iframe
		$('#video-frame').attr('src', videoUrl);

		//Show modal when video is done loading
		$('#video-frame').load(function () {
			// When we clear the iframe src on close it causes the load event to fire again.
			// This prevents the modal from reopening when we clear the src on close
			if ($('#video-frame').attr('src') !== '') {
				$('#video-modal').modal();
			}
		});

		// Replace loader with play button and reattach event handler
		$('#video-modal').on('shown.bs.modal', function () {
			$placeholder.html(playButtonTemplate);
			$placeholder.children('button').on('click', playVideoModal);
		});

		// Stop video from playing when modal is closed
		$('#video-modal').on('hidden.bs.modal', function () {
			$('#video-frame').attr('src', '');
		});
	};

	return {
		init: function () {

			var $placeholders = $('[data-video-placeholder]');

			if ($placeholders.length > 0) {

				$('body').prepend(modalTemplate);

				$placeholders.each(function () {
					var videoId = $(this).data('video-placeholder');
					var location = $(this).data('video-location');
					var backgroundImage = `url(http://img.youtube.com/vi/${videoId}/hqdefault.jpg)`;

					// Add YT image as placeholder background
					$(this).css({'background-image': backgroundImage}).append(playButtonTemplate);

					// Add event handler got playing video
					if (location === 'modal') {
						$(this).children('button').on('click', playVideoModal);
					}
				});
			}
		}
	}
}(jQuery);

placeholderVideo.init();


// Single Page Fixed Buttons on Side
//===========================================
var staticButtons = function ($) {
	var $buttons = $('[data-sticky-buttons]');
	var $container = $('.single-main');
	var offsetSpacingLeft = 45;
	var offsetSpacingTop = 15;
	var responsiveBreakpoint = 1100;

	var setDefaultPosition = function () {
		$buttons.css({'position': 'absolute'});

		var topPos = (parseInt($container.css('marginTop')) * -1) + offsetSpacingTop;
		var rightPos = ($buttons.width() + offsetSpacingLeft) * -1;

		var cssPosition = {
			'position': 'absolute',
			'top': topPos,
			'right': rightPos,
			'bottom': 'auto',
			'left': 'auto'
		};

		$buttons.css(cssPosition);
	};

	var setFixedScrollPosition = function () {
		var leftPos = $container.offset().left + $container.outerWidth() + offsetSpacingLeft;

		var cssPosition = {
			'position': 'fixed',
			'top': offsetSpacingTop,
			'right': 'auto',
			'bottom': 'auto',
			'left': leftPos
		};

		$buttons.css(cssPosition);
	};

	var setBottomPosition = function () {
		$buttons.css({'position': 'absolute'});

		var rightPos = ($buttons.width() + offsetSpacingLeft) * -1;

		var cssPosition = {
			'position': 'absolute',
			'top': 'auto',
			'right': rightPos,
			'bottom': offsetSpacingTop,
			'left': 'auto'
		};

		$buttons.css(cssPosition);
	};

	var setPosition = function () {

		// Do not position buttons when in mobile
		if (window.innerWidth <= responsiveBreakpoint) {
			$buttons.attr('style', '');
			return;
		}

		// Figure out window position and set position acccrodingly
		var windowScrollPos = $(window).scrollTop();
		var topScrollPoint = $container.offset().top + (parseInt($container.css('marginTop')) * -1) + offsetSpacingTop;
		var bottomScrollPont = $container.offset().top + $container.outerHeight() - $buttons.outerHeight() - offsetSpacingTop;

		if (windowScrollPos < topScrollPoint) {
			setDefaultPosition();
		} else if (windowScrollPos >= topScrollPoint && windowScrollPos < bottomScrollPont) {
			setFixedScrollPosition();
		} else {
			setBottomPosition();
		}
	};

	return {
		init: function () {

			if ($buttons.length > 0) {
				setPosition();
				$(window).scroll(setPosition);
				$(window).resize(setPosition);
			}
		}
	}

}(jQuery);

jQuery(window).load(function () {
	staticButtons.init();
});

// Search tag handling
//===========================================
var searchTagHandling = function ($) {

	var tagHandle = function () {
		let search = window.location.search;
		if (search.length > 0) {
			let chunks = search.replace('?', '').split('&');
			chunks.forEach(function (el) {
				if (el.includes('t=')) {
					let willClickTerm = el.replace('t=', '');
					$('input[value="' + willClickTerm + '"]').click();
					$('[data-ajax="true"]').click();
				}
			});
		}
	};

	//	Initialize
	return {
		init: function () {
			tagHandle();
		}
	}

}(jQuery);


// AJAX handling
//===========================================
var ajaxHandling = function ($) {
	var ajax = $('[data-ajax="true"]');
	var ajaxData = ajax.data('ajaxdata');
	var tags = $('[name="tag_filter"]');
	var categories = $('[name="search_filter"]');
	var spinner = ajax.next();
	var search = $('form.blog-search-form');
	var searchField = $('#search-terms');

	//	Handle the AJAX request
	var createAjaxHandler = function () {
		ajax.click(function (e) {
			e.preventDefault();
			$.ajax({
				url: ajaxData.endpoint,
				dataType: 'HTML',
				method: 'POST',
				data: ajaxData,
				beforeSend: function () {
					ajax.hide();
					spinner.show();
				},
				error: function () {
					ajax.hide();
					spinner.hide();
				},
				complete: function () {
					spinner.hide();
				},
				success: function (data) {
					console.log(data);
					appendDataIntoDom(data);
					updateAjaxDataAttributes();
					checkAjaxNecessity();
				}
			});
			return false;
		});
	};

	//	Handle whenever the category radio button input changes
	var createCategoryHandler = function () {
		categories.change(function () {
			resetDataAttributes();
		});
	};

	//	Handle whenever the radio button input changes
	var createTagHandler = function () {
		tags.change(function () {
			resetDataAttributes();
		});
	};

	//	Handle whenever the search form changes
	var createSearchHandler = function () {
		search.submit(function (e) {
			e.preventDefault();
			resetDataAttributes();
			return false;
		});
	};

	//	Reset the data attributes of the search form
	var resetDataAttributes = function () {
		//	Remove all posts
		$('article.feed-post').remove();
		$('article.search-page-result').remove();
		$('div.no-results').remove();

		//	Reset the data attributes as necessary
		ajaxData.current_page = 0;
		delete ajaxData.categories;
		delete ajaxData.tags;
		delete ajaxData.s;

		//	Handle categories
		if (categories.filter(':checked').length > 0 && categories.filter(':checked').val() !== '0') {
			ajaxData.categories = categories.filter(':checked').val();
		}

		//	Handle tags
		if (tags.filter(':checked').length > 0 && tags.filter(':checked').val() !== '0') {
			ajaxData.tags = tags.filter(':checked').val();
		}

		//	Handle search
		if (searchField.val().length > 0) {
			ajaxData.s = searchField.val();
		}

		//	Initiate the AJAX request
		ajax.click();
	};

	//	Append the data into the DOM
	var appendDataIntoDom = function (data) {
		var searchResults = $('div.search-results');
		var searchPageResults = $('div.search-page-results');
		if (searchResults.length > 0) {
			searchResults.append(data);
		}
		else if (searchPageResults.length > 0) {
			searchPageResults.append(data);
		}
	};

	//	Update the data attributes, post-DOM update
	var updateAjaxDataAttributes = function () {
		var foundPosts = $('.found_posts');
		ajaxData.current_page++;
		ajaxData.total_posts = foundPosts.html();
		foundPosts.remove();
	};

	//	Check if we need to show the Load More button
	var checkAjaxNecessity = function () {
		spinner.hide();
		if ($('div.search-results').length > 0 && $('article.feed-post').length >= ajaxData.total_posts) {
			ajax.hide();
		}
		else if ($('div.search-page-results').length > 0 && $('article.search-page-result').length >= ajaxData.total_posts) {
			ajax.hide();
		}
		else {
			ajax.show();
		}
	};

	//	Initialize
	return {
		init: function () {

			checkAjaxNecessity();
			createCategoryHandler();
			createTagHandler();
			createSearchHandler();
			createAjaxHandler();

			//	Do this last, to ensure that the callbacks are in place
			searchTagHandling.init();
		}
	}

}(jQuery);

ajaxHandling.init();

// Donate handling
//===========================================
var donateHandling = function ($) {

	var clickHappened = false;

	var forceNextClick = function () {
		//	If the click happened, return
		if (!clickHappened) {
			clickHappened = true;
		}
		else {
			return;
		}

		//	Wait a small amount of time
		window.setTimeout(function () {
			$('button.gform_next_button#gform_next_button_1_3').click();
		}, 150);
	};

	var onDonationAmountClick = function () {
		$('input[value^="$"]').click(forceNextClick);
	};

	var onHashDetection = function () {
		if (window.location.hash.length > 0) {
			var button = $('input[value="$' + window.location.hash.replace('#', '') + '"]');
			if (button.length > 0) {
				button.click();
			}
		}
	};

	//	Initialize
	return {
		init: function () {
			$(document).bind('gform_post_render', function () {
				onDonationAmountClick();
				onHashDetection();
			});
		}
	}


}(jQuery);
donateHandling.init();


// Equalize Heights
//===========================================
var eqHeight = function ($) {

	var equalize = function (container) {
		var $container = container
		var target = $container.attr('data-eq-height');
		var maxHeight = 0;

		// Reset height before measuring
		$container.children(target).css({'height': 'auto'});

		// Get the max height
		$container.children(target).each(function () {
			if ($(this).get(0).scrollHeight > maxHeight) {
				maxHeight = $(this).get(0).scrollHeight;
			}
		});

		// Set new height
		$container.children(target).css({'height': maxHeight});
	};

	return {
		init: function () {


			var $containers = $('[data-eq-height]');

			if ($containers.length > 0) {

				$(window).load(function () {
					$containers.each(function () {
						equalize($(this));
					});
				});

				$(window).resize(function () {
					$containers.each(function () {
						equalize($(this));
					});
				});
			}
		}
	}
}(jQuery);
eqHeight.init();


// Advocacy handle
//===========================================
var advocacyHandle = function ($) {

	var old_shorturl;

	var clickHandler = function (e) {
		e.preventDefault();

		var shorturl = old_shorturl;
		switch ($(this).html()) {
			case 'AL':
			case 'AZ':
			case 'AR':
			case 'FL':
			case 'GA':
			case 'IN':
			case 'IA':
			case 'KS':
			case 'LA':
			case 'MD':
			case 'MS':
			case 'MT':
			case 'NH':
			case 'NC':
			case 'OH':
			case 'OK':
			case 'PA':
			case 'RI':
			case 'SC':
			case 'SD':
			case 'TN':
			case 'UT':
			case 'VA':
			case 'WI':
				shorturl = '3uwbSbn';
				break;
			case 'DC':
				shorturl = 'kW2EXfF';
				break;
			case 'NV':
				shorturl = 'F22yVDr';
				break;
			case 'Get Started':
				shorturl = 'VSTxcW5';
				break;
			default:
				shorturl = '1s3gXrS';
				break;
		}
		if (shorturl === old_shorturl) {
			return;
		}

		var iframe = $('iframe.advocacy-actionwidget-iframe');
		var src = iframe.attr('src');
		src = src.replace(old_shorturl, shorturl);
		old_shorturl = shorturl;
		iframe.attr('src', src);
		$('#stateModal').modal();

		return false;
	};

	return {
		init: function () {
			old_shorturl = 'VSTxcW5';
			$('a[data-target="#stateModal"]').click(clickHandler);
		}
	}

}(jQuery);
advocacyHandle.init();

// Cookies
//===========================================

function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = "expires="+ d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for(var i = 0; i <ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

function submitInterstitial() {
	setCookie("programSignup", true, 183);
	return false;
}

jQuery(document).bind("gform_confirmation_loaded", function (e, form_id) {
	if (form_id === 2 ||
		form_id === 8 ||
		form_id === 5 ||
		form_id === 7) {
		submitInterstitial();
	}
});



